import { dataProps } from './properties'

export const setLeadList = (state, payload) => {
    state.list = payload
}    

export const setLeadData = (state, payload) => {
    state.props = payload
} 

export const resetLeadData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/leads/mutations.js